















































































































































































import { Vue, Component } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import moment from 'moment';
import { Funcionalidades } from '@/config/funcionalidades';

import { fetchSimSolicitudes } from './fetchSimSolicitudes';
import TablaSimSolicitudes from './TablaSimSolicitudes.vue';
import ComponenteDialogo from './ComponenteDialogo.vue';
import LecturaExcel from './LecturaExcel.vue';

import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModalCrear from '@/reusable/Modal/CabeceraModalCrear.vue';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import CrudStepperHeader from '@/reusable/Mantenedor/CrudStepperHeader.vue';
import CrudStepperItems from '@/reusable/Mantenedor/CrudStepperItems.vue';
import CrudStepperContent from '@/reusable/Mantenedor/CrudStepperContent.vue';

import CabeceraModalSim from './CabeceraModalSim.vue';
import PopUpGeneratedReports from './PopUpGeneratedReports.vue';

@Component({
  components: {
    TablaSimSolicitudes,
    DatePicker,
    ComponenteDialogo,
    LecturaExcel,
    ModalMantenedor,
    CabeceraModalCrear,
    NavegacionModalCrud,
    CrudStepperHeader,
    CrudStepperItems,
    CrudStepperContent,
    CabeceraModalSim,
    PopUpGeneratedReports,
  },
})
export default class SimSolicitudes extends Vue {
  readonly funcionalidad: Funcionalidades = Funcionalidades.SimSolicitudes;
  info: any = [];
  busqueda = '';

  fechaInicio = moment().subtract(1, 'month');
  fechaFin = moment();
  telco: any = '';
  plan: any = '';

  telcoOptions: any = [];
  planOptions: any = [];

  abrirModal = false;
  continuarModal = false;
  pasoActivoIndex = 1;
  mensajeConfirmacion: any = '';
  dialogConfirmacionGuardar = false;

  mostrarBtnVolver = false;
  mostrarBtnContinuar = true;
  mostrarBtnGuardar = false;
  permitirCont = false;
  permitirGuard = false;

  loadingService = new LoadingService();
  $snotify: any;

  jsonSolicitud = {};
  jsonExcel = {};
  planId: 0;
  telcoId: 0;

  showReporteGenerado: boolean = false;
  textoModalReporte = '';

  showPopUpReport: boolean = false;
  msgReport: string = '';

  beforeMount() {
    this.cargaInicialGrilla();
    this.getTelcoOptions();
  }

  readonly pasos: PasosCrud = {
    ingresoDeSim: {
      accion: '',
      visible: true,
      step: 1,
      title: 'Ingreso de SIM',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
    lecturaExcel: {
      accion: '',
      visible: true,
      step: 2,
      title: 'Lectura de Excel',
      icon: 'directions_car',
      codigoSubAccion: 41,
      codigoAccionPadre: CodigoAccion.Crear,
    },
  };

  btnModalContinuar() {
    this.continuarModal = true;
  }

  btnModalGuardar() {
    this.loadingService.showLoading(undefined, 'modalGuardar');
    let body: any = {
      extension: 'csv',
      modulo_id: this.funcionalidad,
      telco_id: this.telcoId,
      plan_id: this.planId,
    };
    fetchSimSolicitudes('exportarReporte', {
      Excel: this.jsonExcel,
      clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
      user_id: JSON.parse(localStorage.getItem('user')).id,
      user_rut: JSON.parse(localStorage.getItem('user')).rutClienteDefecto,
      modulo_id: this.funcionalidad,
      tipo_alerta: 'SIM Ingresos',
      body: body,
    })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.abrirModal = false;
          this.pasoActivoIndex = 1;
          this.textoModalReporte = data.data.MENSAJE_RESPUESTA;
          this.showReporteGenerado = true;
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.abrirModal = false;
          this.pasoActivoIndex = 1;
          this.showReporteGenerado = false;
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.cargaInicialGrilla();
        this.loadingService.hideLoading('modalGuardar');
        this.abrirModal = false;
      });
  }

  objCreacion(obj: any) {
    this.continuarModal = false;
    this.jsonSolicitud = obj;
    this.telcoId = obj.telcoId;
    this.planId = obj.planId;
    this.permitirSeguir();
  }

  excelReaded(obj: any) {
    this.jsonExcel = obj;
    if (this.jsonExcel) this.permitirGuard = true;
  }

  cargaInicialGrilla() {
    this.loadingService.showLoading(undefined, 'cargaInicialGrilla');
    return fetchSimSolicitudes('getSolicitudes', { '': '' })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          if (data.data.data.hasOwnProperty('LISTA'))
            this.info = data.data.data.LISTA;
          else this.info = [data.data.data];
          for (let i in this.info) {
            this.info[i].nombreUsuarioCompleto = `${
              this.info[i].nombre ? this.info[i].nombre : ''
            } ${
              this.info[i].apellidopaterno ? this.info[i].apellidopaterno : ''
            }`;
            if (this.info[i].nombreUsuarioCompleto === ' ')
              this.info[i].nombreUsuarioCompleto = '-';
            if (this.info[i].simingresoestado === '')
              this.info[i].simingresoestadoColor = '🟢 VIGENTE';
            else if (this.info[i].simingresoestado === 'VIGENTE')
              this.info[i].simingresoestadoColor = '🟢 VIGENTE';
            else this.info[i].simingresoestadoColor = '🔴 ANULADO';
          }
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.info = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('cargaInicialGrilla'));
  }

  getTelcoOptions() {
    this.loadingService.showLoading(undefined, 'getTelcoOptions');
    return fetchSimSolicitudes('getTelco', { '': '' })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          const options = data.data.data.LISTA.filter(
            (obj: any) => obj.telconame !== '(Todos)'
          );
          this.telcoOptions = options;
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.telcoOptions = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getTelcoOptions'));
  }

  getPlanOptions() {
    this.loadingService.showLoading(undefined, 'getPlanOptions');
    let fetchBody = {};
    if (this.telco) fetchBody = { telcoid: this.telco.telcoid };
    else fetchBody = { '': '' };
    return fetchSimSolicitudes('getPlan', fetchBody)
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.planOptions = data.data.data.LISTA;
        else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.planOptions = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getPlanOptions'));
  }

  // cabecera Modal Custom //
  volv() {
    if (this.pasoActivoIndex == 2) {
      this.pasoActivoIndex = 1;
      this.mostrarBtnVolver = false;
      this.mostrarBtnContinuar = true;
      this.mostrarBtnGuardar = false;
    }
  }
  cont() {
    if (this.pasoActivoIndex == 1) {
      this.pasoActivoIndex = 2;
      this.mostrarBtnVolver = true;
      this.mostrarBtnContinuar = false;
      this.mostrarBtnGuardar = true;
    }
  }
  guard() {
    this.btnModalGuardar();
    this.mostrarBtnVolver = false;
    this.mostrarBtnContinuar = true;
    this.mostrarBtnGuardar = false;
    this.permitirCont = false;
    this.permitirGuard = false;
  }
  permitirSeguir() {
    this.permitirCont = true;
  }
  quitarGuardar() {
    this.permitirGuard = false;
  }
  // cabecera Modal Custom //

  cerrarModalCrear() {
    this.abrirModal = false;
    this.pasoActivoIndex = 1;
    this.mostrarBtnVolver = false;
    this.mostrarBtnContinuar = true;
    this.mostrarBtnGuardar = false;
    this.permitirCont = false;
    this.permitirGuard = false;
  }

  get estadoId() {
    const { entity } = this.pasos.ingresoDeSim.formState;
    if (!entity) return null;
    return entity.estado;
  }

  get fechaMaxima() {
    const hoy = new Date();
    let fechaMax =
      hoy.getFullYear() +
      '-' +
      this.dosCifras((hoy.getMonth() + 1).toString()) +
      '-' +
      this.dosCifras(hoy.getDate().toString());
    return fechaMax;
  }

  dosCifras(valor: string) {
    return valor.length == 1 ? '0' + valor : valor;
  }

  handleBuscarClick() {
    this.loadingService.showLoading(undefined, 'handleBuscarClick');
    let body = {
      telco: this.telco,
      plan: this.plan,
      fechaInicio: this.fechaInicio,
      fechaFin: this.fechaFin,
    };
    return fetchSimSolicitudes('getSolicitudes', body)
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          if (data.data.data.hasOwnProperty('LISTA'))
            this.info = data.data.data.LISTA;
          else this.info = [data.data.data];
          for (let i in this.info) {
            this.info[i].nombreUsuarioCompleto = `${
              this.info[i].nombre ? this.info[i].nombre : ''
            } ${
              this.info[i].apellidopaterno ? this.info[i].apellidopaterno : ''
            }`;
            if (this.info[i].nombreUsuarioCompleto === ' ')
              this.info[i].nombreUsuarioCompleto = '-';
            if (this.info[i].simingresoestado === '')
              this.info[i].simingresoestadoColor = '🟢 VIGENTE';
            else if (this.info[i].simingresoestado === 'VIGENTE')
              this.info[i].simingresoestadoColor = '🟢 VIGENTE';
            else this.info[i].simingresoestadoColor = '🔴 ANULADO';
          }
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.info = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('handleBuscarClick'));
  }

  clearFilters() {
    this.busqueda = '';
    this.fechaInicio = moment().subtract(1, 'month');
    this.fechaFin = moment();
    this.telco = '';
    this.plan = '';
    this.cargaInicialGrilla();
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  async getCSV(): Promise<void> {
    const self = this;

    const paramsApi: any = {
      telco: self.telco,
      plan: self.plan,
      fechaInicio: self.fechaInicio,
      fechaFin: self.fechaFin,
    };

    const paramsMap: any = {};

    for (const key in paramsApi) {
      if (paramsApi[key]) {
        paramsMap[key] = paramsApi[key];
      }
    }

    const user = localStorage.getItem('user');
    const userId = JSON.parse(user.replace(/'/g, '"')).id;
    const clienteDefecto = localStorage.getItem('clienteDefecto');

    self.loadingService.showLoading();

    return await fetchSimSolicitudes('export_excel', {
      userId,
      clienteDefecto,
      ...paramsMap,
    })
      .then((response: any) => {
        self.loadingService.showLoading();
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return;
        }
        self.msgReport = MENSAJE_RESPUESTA;
        self.showPopUpReport = true;
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3500 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }
} // llave cierre componente
